interface ShareDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

const channels = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-link", label: "复制链接" },
  { icon: "ri-qr-code-line", label: "二维码" },
];

export default function ShareDialog({ open, title, onClose }: ShareDialogProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={onClose} />
      <div className="relative z-10 w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">分享《{title}》</h3>
            <p className="mt-1 text-xs text-foreground-500">演示功能 · 未接入真实分享接口</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full text-foreground-500 transition-colors hover:bg-background-100"
            aria-label="关闭"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {channels.map((c) => (
            <button
              key={c.label}
              type="button"
              className="flex flex-col items-center gap-2 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className={`${c.icon} text-xl`} />
              </span>
              <span className="text-xs text-foreground-600">{c.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5">
          <i className="ri-links-line text-base text-foreground-400" />
          <span className="truncate text-xs text-foreground-500">https://97cinema.demo/detail</span>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full whitespace-nowrap rounded-md bg-primary-500 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}